import React from "react";
import styled from "styled-components";

const Pinkh4 = styled.h4`
  color: #d8127d;
  text-transform: uppercase;
`;

const Location = styled.div`
  padding: 0 0 50px 0;
`;

const LocationList = styled.ul`
  border-top-width: 4px;
  border-top-style: solid;
  padding: 30px 0 30px 0;
`;

const StreetFoodSection = () => (
  <section>
    <Location>
      <h2>STREET FOOD</h2>
      <LocationList>
        <li>
          <Pinkh4>Street Food to be announced very soon!</Pinkh4>
        </li>
      </LocationList>
    </Location>
  </section>
);

export default StreetFoodSection;
